import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IFilterOption } from '@rankmi/rankmi-table/dist/interfaces/filterProps'

import { joinKeys } from 'helpers/translations.helper'
import { IMainState } from 'store/states'
import { EnrolState } from 'enum'
import { prefixTranslation } from '../common'

interface Column extends IFilterOption {
  label: string
  type: string
  value: string
}

const { Approved, Denied, Pending } = EnrolState
const getTranslationKey = (modality: EnrolState) => {
  const modalities = {
    [Approved]: 'approved',
    [Denied]: 'denied',
    [Pending]: 'pending',
  }
  return modalities[modality] || modalities[Pending]
}

export const useFiltersColumns = () => {
  const prefix = joinKeys(prefixTranslation, 'participants.columns')
  const prefixFilters = joinKeys(prefixTranslation, 'participants.status')

  const [filtersColumns, setFilterColumns] = useState<Column[]>([])
  const { t } = useTranslation()
  const { loading: profilesLoading } = useSelector(
    ({ lmsProfiles }: IMainState) => lmsProfiles
  )

  useEffect(() => {
    if (!profilesLoading) {
      setFilterColumns([
        {
          label: t(`${prefix}.user.name`),
          value: 'user_full_name',
          type: 'string',
        },
        {
          label: t(`${prefix}.state`),
          value: 'state',
          type: 'tagsList',
          list: [Approved, Denied, Pending].map((value) => {
            const key = getTranslationKey(value)
            return {
              value: String(value),
              label: t(`${prefixFilters}.${key}`),
            }
          }),
        },
        {
          label: t(`${prefix}.user.position`),
          value: 'user_position',
          type: 'string',
        },
        {
          label: t(`${prefix}.hasCertificate.title`),
          value: 'has_certificate',
          type: 'boolean',
        }
      ])
    }
  }, [prefix, prefixFilters, profilesLoading, t])
  return filtersColumns
}
